import CaseFirstView from 'components/cases/common/CasesFirstView/'
import OverView from 'components/cases/common/Overview/'
import Interview from 'components/cases/kaiho/Interview/'
import CaseStudy from 'components/home/CaseStudy'
import { firstViewItem, overviewTitle, overviewItem, issueSolutionItems } from './KaihoItems'
import MailmagazineLink from 'components/mailmagazine/MailmagazineLink/MailmagazineLink'

const Kaiho = () => {
  return (
    <section>
      <CaseFirstView firstViewItem={firstViewItem} />
      <OverView overviewItem={overviewItem} issueSolutionItems={issueSolutionItems} overviewTitle={overviewTitle} />
      <Interview />
      <CaseStudy enTitle="Case study" jaTitle="事例" tagType="h2" />
      <div>
        <MailmagazineLink />
      </div>
    </section>
  )
}

export default Kaiho
